import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const RAZORPAY_NOISE_PATTERNS = [
  'razorpay',
  'x-rtb-fingerprint-id',
  'request-id',
  'permissions policy violation: accelerometer',
  'serviceworker" must be a dictionary',
  'checkout-static-next.razorpay.com/build/undefined',
  'localhost:37857/',
  'localhost:7070/'
];

const isNoisyRazorpayMessage = (value) => {
  if (value == null) {
    return false;
  }

  const message = String(value).toLowerCase();
  return RAZORPAY_NOISE_PATTERNS.some((pattern) => message.includes(pattern));
};

const shouldSuppressRazorpayNoise = (args) => args.some((arg) => {
  if (isNoisyRazorpayMessage(arg)) {
    return true;
  }

  if (arg && typeof arg === 'object') {
    const nestedMessage = arg.message || arg.reason || arg.stack;
    return isNoisyRazorpayMessage(nestedMessage);
  }

  return false;
});

const originalConsoleError = console.error;
console.error = (...args) => {
  if (shouldSuppressRazorpayNoise(args)) {
    return;
  }
  originalConsoleError(...args);
};

const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  if (shouldSuppressRazorpayNoise(args)) {
    return;
  }
  originalConsoleWarn(...args);
};

window.addEventListener('error', (event) => {
  if (isNoisyRazorpayMessage(event.message) || isNoisyRazorpayMessage(event.filename)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (isNoisyRazorpayMessage(event.reason?.message || event.reason)) {
    event.preventDefault();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
